import { useMemo } from 'react';

const useStepIndexFromConditions = (stepsConditions = []) => {
  const currentStepIndex = useMemo(() => {
    if (!stepsConditions || stepsConditions.length === 0) return 0;
    const activeSteps = stepsConditions
      .map((condition, index) => (condition ? index : -1))
      .filter((index) => index !== -1);

    return activeSteps.length > 0 ? Math.max(...activeSteps) : 0;
  }, [stepsConditions]);

  return currentStepIndex;
};

export default useStepIndexFromConditions;
